import { getMediaDevices } from '@streem/toolbox';

export function getInitialValue<T extends { deviceId: string; label: string }>(
    devices: T[],
    mediaStreamTrack: MediaStreamTrack,
    preferredCameraId: string | null,
): {
    label: string;
    value: string;
} {
    if (preferredCameraId) {
        // check if the camera is still attached
        const attachedDeviceLabel = devices.find(
            device => device.deviceId === preferredCameraId,
        )?.label;

        if (attachedDeviceLabel && mediaStreamTrack.label === attachedDeviceLabel) {
            return {
                label: attachedDeviceLabel,
                value: preferredCameraId,
            };
        }
    }

    const defaultCaptureDevice = devices.find(device => device.label === mediaStreamTrack.label);
    if (defaultCaptureDevice) {
        return {
            label: defaultCaptureDevice.label,
            value: defaultCaptureDevice.deviceId,
        };
    } else {
        return {
            label: '',
            value: '',
        };
    }
}

export let mediaStream: MediaStream | null = null;

export const getCameraFeed = async (deviceId?: string) => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        return;
    }

    const [mediaDevice] = (await getMediaDevices('videoinput')).filter(
        device => device.deviceId === deviceId,
    );

    if (mediaStream) {
        // make sure we stop any active tracks before creating a new one
        // mediaStream.getVideoTracks().forEach(track => console.log('ds logging track', track));
        mediaStream.getVideoTracks().forEach(track => track.stop());
    }

    mediaStream = await navigator.mediaDevices.getUserMedia({
        video: {
            width: { ideal: 445 },
            height: { ideal: 270 },
            ...(mediaDevice && { deviceId: { exact: mediaDevice.deviceId } }),
        },
        audio: false,
    });

    return mediaStream;
};
